export default {
  install (app, options) {
    let local = (name) => {
      return { name: '' + name }
    }

    app.config.globalProperties.$local = local
  }
}
